import React from 'react';
import {Typography} from '@material-ui/core';
import PropTypes, {InferProps} from 'prop-types';
import {FeedbackStyles} from 'assets/tss/layouts/components';

EfeSupportMessage.propTypes = {
    message: PropTypes.string,
    asterisk: PropTypes.bool.isRequired,
};

EfeSupportMessage.defaultProps = {
    message: 'Campos obligatorios',
    asterisk: true,
};

function EfeSupportMessage(
    props: InferProps<typeof EfeSupportMessage.propTypes>
) {
    const {message, asterisk} = props;
    const classes = FeedbackStyles();
    return (
        <Typography className={classes.requiredFields}>
            {message}
            {asterisk && (
                <span>
                    &thinsp;
                    {'*'}
                </span>
            )}
        </Typography>
    );
}

export default EfeSupportMessage;
